import { runningLocally } from 'utils/constants';

export const mainCategoryHomePageMapping: Record<
  string,
  HomePagePrizeComponentCategories
> = {
  trip: 'Trips',
  lifestyle: 'Lifestyle',
  family: 'Family',
  experience: 'Experiences',
  tech: 'Tech',
};

export const homePagePrizeComponentCategories = [
  'Trips',
  'Lifestyle',
  'Family',
  'Experiences',
  'Tech',
] as const;
export type HomePagePrizeComponentCategories =
  (typeof homePagePrizeComponentCategories)[number];

export const homePagePrizeComponentSlugs: Record<
  HomePagePrizeComponentCategories,
  string[]
> = runningLocally
  ? // Local dev
    {
      Trips: [
        'maldives',
        'win-roadtrip-scotland',
        'disneyland-paris-day-tickets',
        'win-camper-van',
        'wellness-retreat-sri-lanka',
        'win-around-the-world-cruise',
        'win-stay-in-the-wood-norton',
      ],
      Lifestyle: ['vw-campervan-roadtrip'],
      Family: ['win-disney-cruise-with-family', 'bottomless-brunch-150'],
      Experiences: [
        'fancy-bottomless-brunch',
        '7-days-in-sicily',
        'bottomless-brunch-30',
      ],
      Tech: ['gadgets-galore-2500', 'gadgets-galore-10000'],
    }
  : {
      Trips: [
        '10-nights-bora-bora',
        'win-stay-in-versailles',
        'win-private-yacht',
        '2-weeks-japan',
        'the-great-migration-in-the-masai-mara',
      ],
      Lifestyle: [
        'win-house-renovation',
        'win-audi-e-tron',
        'luxury-spree-10000',
        'win-a-wedding',
        'win-a-big-green-egg',
      ],
      Family: [
        'disney-world-florida',
        'win-family-stay-at-west-midlands-safari-park-lodge',
        'legoland-denmark',
        'go-ape-zip-trekking-adventure',
        'national-trust-membership',
      ],
      Experiences: [
        'win-camper-van',
        'win-a-cotswolds-luxury-weekend-spa-break',
        'win-coachella-tickets',
        'premier-league-game-vip-tickets',
        'ferrari-experience-in-monaco',
      ],
      Tech: [
        'iphone-17-pro',
        'win-ninja-dualzone-airfryer',
        'a-photographers-dream-2000',
        'nintendo-switch-lite',
        '4k-ultra-hd-home-cinema-projector',
      ],
    };
